<template>
    <div>
        <div class="ml-4" v-for="(value, key) of data">
            <div class="mb-4">
                <div style="color: red;">{{key ? key : ''}}</div>
                <vs-alert>
                    <div v-if="Array.isArray(value)">
                        <response :data="value"></response>
                    </div>
                    <div v-else-if="isObject(value)">
                        <response :data="value"></response>
                    </div>
                    <div v-else>
                        {{value ? value : 'null'}}
                    </div>
                </vs-alert>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'response',
    props: ['data'],

    methods: {
        isObject(val) {
            if (val === null) { return false;}
            return ( (typeof val === 'function') || (typeof val === 'object') );
        }
    }
}
</script>
